var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H7C6.4 0 5.8 0.2 5.3 0.5C5 0.2 4.6 0 4.1 0H1.9C0.9 0 0 0.9 0 1.9V16C0 17.1 0.9 18 1.9 18H2V19.5C2 22 4 24 6.5 24C9 24 11 22 11 19.5V18H21C22.7 18 24 16.7 24 15V3C24 1.3 22.7 0 21 0ZM4 1.9V2.9V14.9C4 15.1 4 15.3 4.1 15.4V15.9H2L1.9 2L4 1.9ZM9 19.5C9 20.9 7.9 22 6.5 22C5.1 22 4 20.9 4 19.5V18H4.1C4.6 18 5 17.8 5.4 17.5C5.8 17.8 6.4 18 7 18H9V19.5ZM22 15C22 15.6 21.6 16 21 16H7C6.4 16 6 15.6 6 15V3C6 2.4 6.4 2 7 2H21C21.6 2 22 2.4 22 3V15Z",
    fill: "#2C94AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H9V6H19V4Z",
    fill: "#2C94AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8H9V10H11V8Z",
    fill: "#2C94AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H13V10H15V8Z",
    fill: "#2C94AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8H17V10H19V8Z",
    fill: "#2C94AB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12H9V14H11V12Z",
    fill: "#2C94AB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H13V14H15V12Z",
    fill: "#2C94AB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H17V14H19V12Z",
    fill: "#2C94AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandline);
export default __webpack_public_path__ + "static/media/landline.aa9bcfcb8bac35585b8adbbc1a9ef08d.svg";
export { ForwardRef as ReactComponent };